import { useState } from "react";
import { ParticipanteRequest } from "../models/participantes";
import { Codeudor } from "../models/codeudor";
import { SeguroCodeudorEdit } from "../models/seguroCodeudorEdit";
import { EliminarSeguro, SeguroCodeudor } from "../models/seguroCodeudor";
import { Dominios, StatusCode } from "../../../utils/enums";
import { selectorTransversal } from "../../../dtos/selector";
import {
    createSeguroCodeudor, getCodeudor, getCodigosPoliza, getCodPolizasInternas, getSeguroCodeudor,
    getSegurosCodeudor, updateSeguroCodeudor, getMontoAsegurado, deleteCodeudor,
    deleteSeguroCodeudor
} from "../services/servicesCodeudor";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../services/servicesDominio";
import { getOperacion } from "../services/servicesOperacion";
import { operacion } from "../models/operacion";
import { useToast } from "../../../hooks/useToast";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

interface TiposDeudaCodeudor {
    codigo: string,
    glosa: string
}

interface TiposDeudaCodeudorSelect {
    value: string,
    label: string
}

export function useCodeudor() {
    const [tiposDeudaCodeudorSelect, setTiposDeudaCodeudorSelect] = useState<TiposDeudaCodeudorSelect[]>([]);
    const [tiposSegurosCodeudorSelect, setTiposSegurosCodeudorSelect] = useState<selectorTransversal[]>([]);
    const [polizasSelect, setPolizasSelect] = useState<selectorTransversal[]>([]);
    const [polizasInternasSelect, setPolizasInternasSelect] = useState<selectorTransversal[]>([]);
    const [operacion, setOperacion] = useState<operacion>();
    const [montoAseguradoCalculado, setMontoAseguradoCalculado] = useState<number>(0);
    const [seguroCodeudorDefaultValues] = useState<SeguroCodeudorEdit>({
        mutuoId: 0,
        rut: '',
        tipoSeguro: '',
        codigoPoliza: '',
        codigoInternoPoliza: '',
        tienePrima: false,
        companiaSeguros: '',
        descripcionSeguro: '',
        tasa: 0,
        montoPrimaAnual: 0,
        montoAsegurado: 0,
        mesesGratuidad: 0,
        montoPrimaDividendo: 0
    });
    const { addToast } = useToast();


    const obtenerCodeudor = async (dataRequest: ParticipanteRequest): Promise<Codeudor | void> => {

        const resp: AxiosResponse = await getCodeudor(dataRequest)
        if (resp.status === StatusCode.Ok) {
            const dataCodeudor: Codeudor = await resp.data;

            return dataCodeudor;
        }
    }

    const eliminarCodeudor = async (dataRequest: ParticipanteRequest) => {
        const resp: AxiosResponse = await deleteCodeudor(dataRequest);
        return resp;
    }

    const tiposDeudaCodeudor = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_DEUDA)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setTiposDeudaCodeudorSelect(data);
        }
        return;
    }

    const obtenerSegurosCodeudor = async (mutuoId: number, rut: string | undefined): Promise<SeguroCodeudor[]> => {

        const resp: AxiosResponse<ListResponseDto<SeguroCodeudor>> = await getSegurosCodeudor(mutuoId, rut)
        if (resp.status === StatusCode.Ok) {
            const dataSeguros: SeguroCodeudor[] = await resp.data.items;
            return dataSeguros;
        }

        return [];
    }

    const obtenerSeguroCodeudor = async (mutuoId: number, rut: string, tipoSegiro: string): Promise<SeguroCodeudorEdit | void> => {

        const resp: AxiosResponse = await getSeguroCodeudor(mutuoId, rut, tipoSegiro)
        if (resp.status === StatusCode.Ok) {
            const dataSeguro: SeguroCodeudorEdit = await resp.data;

            return dataSeguro;
        }
    }

    const obtenerTiposSeguros = async (dominio: Dominios) => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(dominio)

        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setTiposSegurosCodeudorSelect(data);
        }
    }

    const obtenerPolizas = async (tipoSeguro: string) => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getCodigosPoliza(tipoSeguro);
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setPolizasSelect(data);
        }
    }

    const obtenerPolizasInternas = async (codigoPoliza: string, tipoSeguro: string) => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getCodPolizasInternas(codigoPoliza, tipoSeguro);
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setPolizasInternasSelect(data);
        }
    }



    const actualizarSeguroCodeudor = async (seguro: SeguroCodeudorEdit): Promise<void> => {

        await updateSeguroCodeudor(seguro);

    }

    const crearSeguroCodeudor = async (seguro: SeguroCodeudorEdit): Promise<void> => {

        await createSeguroCodeudor(seguro);

    }

    const obtenerOperacion = async (idMutuo: number) => {
        const resp: AxiosResponse = await getOperacion(idMutuo);
        if (resp.status === StatusCode.Ok) {
            const data: operacion = await resp.data;
            setOperacion(data);
        }
    }

    const obtenerMontoAsegurado = async (mutuoId: number, tipoSeguro: string) => {
        const montoAsegurado: number = await getMontoAsegurado(mutuoId, tipoSeguro);
        setMontoAseguradoCalculado(montoAsegurado);
    }

    const eliminarSeguroCodeudor = async (dataDelete: EliminarSeguro, renderizar: () => void) => {
        const resp: AxiosResponse = await deleteSeguroCodeudor(dataDelete);
        if (resp.status === StatusCode.NoContent) {
            renderizar();
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'El seguro ha sido eliminado correctamente.'
            });

        }
    }

    return {
        obtenerCodeudor,
        obtenerSegurosCodeudor,
        obtenerSeguroCodeudor,
        tiposDeudaCodeudor,
        tiposDeudaCodeudorSelect,
        obtenerTiposSeguros,
        tiposSegurosCodeudorSelect,
        obtenerPolizas,
        polizasSelect,
        obtenerPolizasInternas,
        polizasInternasSelect,
        setPolizasInternasSelect,
        actualizarSeguroCodeudor,
        seguroCodeudorDefaultValues,
        setPolizasSelect,
        crearSeguroCodeudor,
        obtenerOperacion,
        operacion,
        obtenerMontoAsegurado,
        montoAseguradoCalculado,
        eliminarCodeudor,
        eliminarSeguroCodeudor
    }
}

